import { Id } from '../ids';
export const useId = (htmlId, debugParts = []) => {
    return Id.create(htmlId, debugParts);
};
//# sourceMappingURL=useId.js.map